import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import posthog from 'posthog-js';

import { routeTree } from './routeTree.gen';
import './index.css';

// Initialize PostHog
if (import.meta.env.VITE_POSTHOG_API_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    person_profiles: 'always', // Create profiles for anonymous users too
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-capture-attribute-phone-number]',
    },
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
  });
} else {
  console.warn('[PostHog] API key not configured, analytics disabled');
}

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

// Create the router
const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
});

const rootElement = document.getElementById('root');
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
